"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSendBccEmailConfirmationRequestStatus = exports.getResendBccEmailConfirmationRequestStatus = exports.getDisableBccEmailRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getDisableBccEmailRequestStatus = (0, _getRequestStatus.default)(_actions.BccEmailActionTypes.DISABLE_BCC_EMAIL);
exports.getDisableBccEmailRequestStatus = getDisableBccEmailRequestStatus;
var getResendBccEmailConfirmationRequestStatus = (0, _getRequestStatus.default)(_actions.BccEmailActionTypes.RESEND_BCC_EMAIL_CONFIRMATION);
exports.getResendBccEmailConfirmationRequestStatus = getResendBccEmailConfirmationRequestStatus;
var getSendBccEmailConfirmationRequestStatus = (0, _getRequestStatus.default)(_actions.BccEmailActionTypes.SEND_BCC_EMAIL_CONFIRMATION);
exports.getSendBccEmailConfirmationRequestStatus = getSendBccEmailConfirmationRequestStatus;